<template>
  <v-list-item-title
    class="font-weight-black fz-18-px cursor-pointer d-flex align-center"
    @click="changeCurRef(data.refKey)"
  >
    <v-list-item-icon class="mr-0-px my-6-px">
      <v-icon
        class="fz-20-px"
        :class="{
          'amber--text text--darken-3': data.level == 3,
          'light-blue--text text--darken-3': data.level == 4
        }"
        v-text="iconKey"
      ></v-icon>
    </v-list-item-icon>
    <v-hover>
      <template v-slot:default="{ hover }">
        <div class="topic-text d-inline-flex px-8-px relative minw-50-pct">
          <template v-if="data[topicKey]">
            {{ data[topicKey] }}
          </template>
          <template v-else>{{ data.topic }}</template>
          <v-fade-transition v-if="modifyMode.show && editedAuth">
            <v-overlay
              v-if="hover"
              absolute
              :color="hoverColor"
              class="fz-16-px"
            >
              <v-btn
                plain
                class="px-8-px"
                @click.stop="openDialog('editItemSwap', data)"
              >
                <v-icon left>mdi-sort</v-icon>
                排序
              </v-btn>
              <v-btn
                plain
                class="px-8-px"
                @click.stop="openDialog('editItem', data)"
              >
                <v-icon left>mdi-square-edit-outline</v-icon>
                EDIT
              </v-btn>
            </v-overlay>
          </v-fade-transition>
        </div>
      </template>
    </v-hover>
  </v-list-item-title>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Title',

  props: ['index', 'sub_i', 'data', 'hoverColor', 'modifyMode', 'editedAuth'],

  computed: {
    ...mapState('common', ['lang']),
    topicKey() {
      return this.lang === 'en' ? 'topicEn' : 'topic'
    },
    iconKey() {
      let key = ''
      switch (this.data.level) {
        case 3:
          key = 'mdi-rhombus-medium'
          break
        case 4:
          key = 'mdi-rhombus-medium-outline'
          break
      }
      return key
    }
  },

  data() {
    return {}
  },

  methods: {
    ...mapActions('document', ['setCreateMode', 'setDialogChapter']),
    openDialog(key, item) {
      if (item.level > 2) {
        this.setDialogChapter({ key: key, data: item })
      }
    },
    changeCurRef(ref) {
      const fullPath =
        this.$route.path + '?menuId=' + this.$route.query.menuId + '&ref=' + ref
      if (this.$route.fullPath !== fullPath) {
        this.$router.push(fullPath)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__title {
  padding: 16px 0 !important;
  margin: 0 -25px;
  span {
    position: relative;
    display: inline-block;
    min-width: 100px;
  }
}
.topic-text {
  // word-break: break-all;
}
</style>
